export default __webpack_public_path__ + "static/media/aqua_white.444eeefc.png";